import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { I18nextProvider } from 'react-i18next'
import { queryClient } from 'lib/react-query'
import { Provider } from 'react-redux'
import i18n from 'config/localization/i18n'
import { store } from 'config/user/store'
import { ContextProvider } from 'contexts/Contexts'
import DynamicThemeProvider from 'theme/themeProvider'

export default function Providers({ children }: React.PropsWithChildren<any>) {
  const contextProviders = [ContextProvider]

  const contextApiProviders = contextProviders.reduceRight(
    (acc, Provider) => <Provider>{acc}</Provider>,
    <DynamicThemeProvider>{children}</DynamicThemeProvider>
  )

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>{contextApiProviders}</I18nextProvider>
      </Provider>
    </QueryClientProvider>
  )
}
